import ReactMarkdown from "react-markdown";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";

const A = ({ href = "", children }) =>
  href.startsWith("/") ? <Link to={href}>{children}</Link> : <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;

/** Renders rich-text HTML (sanitised) or legacy Markdown. */
export function Markdown({ children, className = "prose-jt", testId }) {
  if (!children) return null;
  if (children.trim().startsWith("<"))
    return <div className={className} data-testid={testId} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(children.replace(/<h1/g, "<h2").replace(/<\/h1>/g, "</h2>")) }} />;
  return (
    <div className={className} data-testid={testId}>
      <ReactMarkdown components={{ a: A, h1: "h2" }}>{children}</ReactMarkdown>
    </div>
  );
}
